import CustomDateRange from "components/Atoms/CustomDateRange"
import StaticMultiSelector from "components/Atoms/StaticMultiSelector"
import DynamicMultiSelector from "components/Molecules/DynamicMultiSelector"
import SearchFilter, {
  SearchFilterCallout,
} from "components/Organisms/SearchFilter"
import React, { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
// import { ORDER_STATUSES } from "../../data/static.items";
import { useQuery } from "@apollo/client"
import StaticSelector from "components/Atoms/StaticSelector"
import { SELLABLE_ITEMS, USERS } from "graphql/selector.queries.gql"
import { DC_PINCODES } from "graphql/survey-areas/survey-areas.queries.gql"
import useAuth from "hooks/useAuth"
import {
  CLOSE_DISPATCH_FILTER,
  OPEN_DISPATCH_FILTER,
} from "store/dispatch.redux"
import { useFilter } from "store/search-filter/search-filter.reducer"
import { ORDER_STATUSES } from "../../data/orderStatuses"
import { ORDER_TYPES } from "../../data/orderTypes"

const DispatchFilter = () => {
  const isOpen = useSelector((state: any) => state.dispatch.isFilterOpen)
  const [filter, setFilter] = useFilter("dispatch")
  const { distributionCentres, user } = useAuth()
  const { data } = useQuery(DC_PINCODES, {
    variables: {
      distributionCentreIds: distributionCentres?.map(obj => obj.id) || [],
    },
  })
  const dcPincodes =
    data?.allSurveyAreas.map(surveyArea => ({ ...surveyArea.properties })) || []
  const dispatch = useDispatch()
  const handleClose = useCallback(() => {
    dispatch({
      type: CLOSE_DISPATCH_FILTER,
    })
  }, [dispatch])

  const handleOpen = useCallback(() => {
    dispatch({
      type: OPEN_DISPATCH_FILTER,
    })
  }, [dispatch])

  return (
    <>
      <SearchFilter
        onOpen={handleOpen}
        isOpen={isOpen}
        onClose={handleClose}
        badgeClassName="mr-3"
        value={filter}
        getValues={setFilter}
        onClear={() => setFilter({})}
      >
        <SearchFilterCallout title="Order">
          <CustomDateRange
            path="dateRange"
            className="mb-3 mt-3"
            label="Date Range"
            inline
            big={false}
          />
          <StaticMultiSelector
            fill
            inline
            formClassName="mb-3"
            path="orderStatus"
            label="Status"
            items={ORDER_STATUSES?.filter(
              s => s.id === "RFS" || s.id === "IPR"
            )}
          />
          <DynamicMultiSelector
            fill
            inline
            label="Placed By"
            path="placedById"
            formClassName="mb-3 vt-search-filter-drawer"
            query={USERS}
            renderTag={item => item?.fullName ?? ""}
            renderText={item => {
              return item?.fullName ?? "Select User..."
            }}
            searchBy={["fullName"]}
            variables={{
              group: "Order Manager",
            }}
          />
          <DynamicMultiSelector
            fill
            inline
            label="Sellable Items"
            path="sellableItemIds"
            formClassName="mb-3 vt-search-filter-drawer"
            query={SELLABLE_ITEMS}
          />
          <StaticMultiSelector
            fill
            inline
            label="Types"
            formClassName="mb-3 vt-search-filter-drawer"
            path="orderCategories"
            items={ORDER_TYPES}
            renderLabel={item => item?.id}
          />
          <StaticSelector
            fill
            label="Department"
            inline
            formClassName="mb-3 vt-search-filter-drawer"
            path="placedInId"
            items={user?.departments}
          />
        </SearchFilterCallout>

        <SearchFilterCallout title="Region">
          <StaticMultiSelector
            fill
            inline
            formClassName="mb-3 vt-search-filter-drawer"
            path="distributionCentreIds"
            label="Storage Locations"
            items={distributionCentres}
          />
          <StaticMultiSelector
            fill
            inline
            formClassName="mb-3 vt-search-filter-drawer"
            path="pincodes"
            label="Pincodes"
            items={dcPincodes}
            renderLabel={item => item?.id}
            searchBy={["id", "name", "distributionCentre.name"]}
            renderText={item =>
              `${item.name} (${item?.distributionCentre?.name})`
            }
          />
        </SearchFilterCallout>
      </SearchFilter>
    </>
  )
}

export default DispatchFilter
